import { useCallback, useEffect, useRef, useState } from "react";
import { Alert } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  organizerAddEventApi,
  organizerMeApi,
  organizerUpdateEventApi,
  organizerSendCertificatesApi,
  organizerSendWinnerCertificatesApi,
  organizerPreviewCertificateApi,
  organizerListEventsApi,
  organizerScannerAttendeeListApi,
  getCategory,
  getState,
  getCityByStateId,
  getEventById,
} from "../../api/api";
import { organizerTicketTypesByEventApi } from "../../api/api";
import { handleError } from "../../helpers/handleError";
import { MAIN_API } from "../../api/apilist";
import SpinLoading from "../../components/spinLoading/SpinLoading";
import OrganizerPillSelect from "../components/OrganizerPillSelect";
import { normalizeTicketPromotion } from "../../helpers/ticketPromotions";
import { resolveTicketsPerUnit } from "../../helpers/ticketTypes";
import "./EventForm.css";
import { EFDatePill, EFTimePill } from "../components/EventFormPickers";
import EventAddressMap from "./EventAddressMap";
import defaultCertificateTemplate from "../../assets/template/Certificado.jpg";
import defaultWinnersCertificateTemplate from "../../assets/template/Certificado ganadores.jpg";



// Event coords: own lat/lng first, legacy venue coords as fallback. "" when not numeric.
const coordOf = (...candidates) => {
  for (const c of candidates) {
    if (c === "" || c == null) continue;
    const n = Number(c);
    if (Number.isFinite(n)) return n;
  }
  return "";
};

const EventForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const editing = Boolean(id);
  const eventFromState = state?.event || null;
  const [isLoading, setIsLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [form, setForm] = useState({
    name: "",
    description: "",
    categoryid: "",
    cityid: "",
    stateid: "",
    address: "",
    lat: "",
    lng: "",
    startDate: "",
    endDate: "",
    timeFrom: "",
    timeTo: "",
    isFree: true,
    price: 0,
    booking: true,
    maxbooking: 100,
    maxTicketsPerUser: 4,
    instagram: "",
    certificatesEnabled: false,
    certificateTitle: "",
    certificateSubtitle: "",
    certificateBody: "",
    certificateSignerName: "",
    certificateSignerRole: "",
    certificateSigner2Name: "",
    certificateSigner2Role: "",
    certificateIssuer: "",
    certificateEmailSubject: "",
    certificateEmailBody: "",
    certificateSendEmail: true,
    certificateWinnersEnabled: false,
    certificateWinnersBody: "",
  });
  const [image, setImage] = useState(null);
  const [coverImagePreview, setCoverImagePreview] = useState("");
  const [mobileImage, setMobileImage] = useState(null);
  const [galleryDesktopImage, setGalleryDesktopImage] = useState(null);
  const [galleryMobileImage, setGalleryMobileImage] = useState(null);
  const [galleryDesktopPreview, setGalleryDesktopPreview] = useState("");
  const [galleryMobilePreview, setGalleryMobilePreview] = useState("");
  const [certificateTemplate, setCertificateTemplate] = useState(null);
  const [certificateWinnersTemplate, setCertificateWinnersTemplate] = useState(null);
  const [certificateLogo, setCertificateLogo] = useState(null);
  const [certificateSignature, setCertificateSignature] = useState(null);
  const [certificateSignature2, setCertificateSignature2] = useState(null);
  const [clearCertificateTemplate, setClearCertificateTemplate] = useState(false);
  const [clearCertificateWinnersTemplate, setClearCertificateWinnersTemplate] = useState(false);
  const [clearCertificateLogo, setClearCertificateLogo] = useState(false);
  const [clearCertificateSignature, setClearCertificateSignature] = useState(false);
  const [clearCertificateSignature2, setClearCertificateSignature2] = useState(false);
  const [currentCover, setCurrentCover] = useState("");
  const [currentMobileCover, setCurrentMobileCover] = useState("");
  const [mobileImagePreview, setMobileImagePreview] = useState("");
  const [currentGalleryDesktop, setCurrentGalleryDesktop] = useState("");
  const [currentGalleryMobile, setCurrentGalleryMobile] = useState("");
  const [clearGalleryDesktop, setClearGalleryDesktop] = useState(false);
  const [clearGalleryMobile, setClearGalleryMobile] = useState(false);
  const [currentCertificateTemplate, setCurrentCertificateTemplate] = useState("");
  const [currentCertificateWinnersTemplate, setCurrentCertificateWinnersTemplate] = useState("");
  const [currentCertificateLogo, setCurrentCertificateLogo] = useState("");
  const [currentCertificateSignature, setCurrentCertificateSignature] = useState("");
  const [currentCertificateSignature2, setCurrentCertificateSignature2] = useState("");
  const [ticketTypes, setTicketTypes] = useState([]);
  const [error, setError] = useState("");
  const [dragTarget, setDragTarget] = useState("");
  const [saving, setSaving] = useState(false);
  const [certStatus, setCertStatus] = useState("");
  const [certSending, setCertSending] = useState(false);
  const [certPreviewing, setCertPreviewing] = useState(false);
  const [winnerCandidates, setWinnerCandidates] = useState([]);
  const [winnerSearch, setWinnerSearch] = useState("");
  const [winnerSelection, setWinnerSelection] = useState({});
  const [winnerStatus, setWinnerStatus] = useState("");
  const [winnerLoading, setWinnerLoading] = useState(false);
  const [winnerSending, setWinnerSending] = useState(false);
  const [certPanelOpen, setCertPanelOpen] = useState(false);
  const [templateCacheKey, setTemplateCacheKey] = useState(() => Date.now());
  const [winnersTemplateCacheKey, setWinnersTemplateCacheKey] = useState(() => Date.now());
  const backendDefaultTemplateUrl = `${MAIN_API}/assets/certificates/Certificado.jpg?v=${templateCacheKey}`;
  const certificateFallback = backendDefaultTemplateUrl || defaultCertificateTemplate;
  const backendDefaultWinnersTemplateUrl = `${MAIN_API}/assets/certificates/Certificado_ganadores.jpg?v=${winnersTemplateCacheKey}`;
  const certificateWinnersFallback = backendDefaultWinnersTemplateUrl || defaultWinnersCertificateTemplate;
  const [categories, setCategories] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [organizerProfile, setOrganizerProfile] = useState(null);
  const prefillRef = useRef(false);
  const organizerType = String(organizerProfile?.organizerType || "FULL_ACCESS").toUpperCase();
  const isFreeOnlyOrganizer = organizerType === "FREE_ONLY";
  const selectedCategory = categories.find((c) => String(c._id || c.id) === String(form.categoryid));
  const selectedCategoryName =
    selectedCategory?.name || eventFromState?.categoryid?.name || eventFromState?.category?.name || "";
  const isSportsCategory = /deporte|sports/i.test(String(selectedCategoryName || ""));
  const certificatesEnabled = isSportsCategory && form.certificatesEnabled;
  const winnersEnabled = certificatesEnabled && form.certificateWinnersEnabled;
  const certificatePreview = currentCertificateTemplate || certificateFallback || defaultCertificateTemplate;
  const winnersCertificatePreview =
    currentCertificateWinnersTemplate || certificateWinnersFallback || defaultWinnersCertificateTemplate;
  const resolveUrl = (u) => {
    if (!u) return "";
    if (/^https?:\/\//i.test(u)) return u;
    if (/^blob:/i.test(u)) return u;
    if (u.startsWith('/')) return `${MAIN_API}${u}`;
    return `${MAIN_API}/${u}`;
  };
  const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
  const MAX_UPLOAD_LABEL = "10 MB";
  const pickValidUpload = (file, label, inputEl) => {
    if (!file) return null;
    if (file.size <= MAX_UPLOAD_BYTES) return file;
    setError(`${label}: el archivo supera el máximo permitido de ${MAX_UPLOAD_LABEL}.`);
    if (inputEl) inputEl.value = "";
    return null;
  };
  const createDropHandlers = (key, onFile) => ({
    onDragEnter: (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragTarget(key);
    },
    onDragOver: (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragTarget(key);
    },
    onDragLeave: (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.currentTarget.contains(e.relatedTarget)) return;
      setDragTarget((prev) => (prev === key ? "" : prev));
    },
    onDrop: (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragTarget((prev) => (prev === key ? "" : prev));
      const file = e.dataTransfer?.files?.[0] || null;
      if (file) onFile(file);
    },
  });
  const defaultPromotion = () => ({
    enabled: false,
    ticketsRequired: 4,
    ticketsCharged: 2,
    label: "4x2",
  });
  const getTicketPromotion = (ticket) => {
    const normalized = normalizeTicketPromotion(ticket?.promotion);
    if (normalized.enabled) return normalized;
    const fallback = ticket?.promotion || defaultPromotion();
    const ticketsRequired = Math.max(2, Number(fallback?.ticketsRequired || 4));
    const ticketsCharged = Math.max(1, Math.min(ticketsRequired - 1, Number(fallback?.ticketsCharged || 2)));
    return {
      enabled: Boolean(fallback?.enabled),
      ticketsRequired,
      ticketsCharged,
      label: String(fallback?.label || `${ticketsRequired}x${ticketsCharged}`),
    };
  };
  const setTicketPromotion = (idx, patch) => {
    setTicketTypes((arr) =>
      arr.map((x, i) => {
        if (i !== idx) return x;
        const next = { ...getTicketPromotion(x), ...patch };
        const ticketsRequired = Math.max(2, Number(next.ticketsRequired || 2));
        const ticketsCharged = Math.max(1, Math.min(ticketsRequired - 1, Number(next.ticketsCharged || 1)));
        return {
          ...x,
          promotion: {
            enabled: Boolean(next.enabled),
            ticketsRequired,
            ticketsCharged,
            label: `${ticketsRequired}x${ticketsCharged}`,
          },
        };
      })
    );
  };
  const isCategoryImage = (candidate, source) => {
    if (!candidate || !source) return false;
    const category = source?.categoryid || source?.category || {};
    const categoryImages = [
      category?.image,
      category?.headerimage,
      category?.headerImage,
    ].filter(Boolean);
    return categoryImages.includes(candidate);
  };
  const fetchAsFile = async (url, filename) => {
    const res = await fetch(url);
    const blob = await res.blob();
    return new File([blob], filename, { type: blob.type || "image/jpeg" });
  };
  const toArray = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val.filter(Boolean);
    if (typeof val === 'string') return val.split(/[\n\r,]+/).map((s) => s.trim()).filter(Boolean);
    return [];
  };
  const pickGallery = (...candidates) => {
    for (const c of candidates) {
      const arr = toArray(c);
      if (arr.length) return arr;
    }
    return [];
  };
  const parseBool = (val, fallback = false) => {
    if (val === undefined || val === null) return fallback;
    if (typeof val === "string") return val === "true" || val === "1";
    return Boolean(val);
  };
  const resolveCertificate = (source = {}) => {
    const cert =
      source?.certificates ||
      source?.certificate ||
      source?.certificateConfig ||
      source?.certificado ||
      {};
    return {
      certificatesEnabled: parseBool(
        cert?.enabled ??
          cert?.isEnabled ??
          source?.certificatesEnabled ??
          source?.certificateEnabled ??
          source?.certificadoHabilitado
      ),
      certificateTitle: cert?.title ?? source?.certificateTitle ?? "",
      certificateSubtitle: cert?.subtitle ?? source?.certificateSubtitle ?? "",
      certificateBody: cert?.body ?? source?.certificateBody ?? source?.certificateText ?? "",
      certificateSignerName: cert?.signerName ?? source?.certificateSignerName ?? "",
      certificateSignerRole: cert?.signerRole ?? source?.certificateSignerRole ?? "",
      certificateSigner2Name: cert?.signer2Name ?? source?.certificateSigner2Name ?? "",
      certificateSigner2Role: cert?.signer2Role ?? source?.certificateSigner2Role ?? "",
      certificateIssuer: cert?.issuer ?? source?.certificateIssuer ?? "",
      certificateEmailSubject: cert?.emailSubject ?? source?.certificateEmailSubject ?? "",
      certificateEmailBody: cert?.emailBody ?? source?.certificateEmailBody ?? "",
      certificateSendEmail: parseBool(
        cert?.sendEmail ?? source?.certificateSendEmail ?? source?.certificatesSendEmail,
        true
      ),
      certificateWinnersEnabled: parseBool(
        cert?.winnersEnabled ??
          source?.certificateWinnersEnabled ??
          source?.certificatesWinnersEnabled,
        false
      ),
      certificateWinnersBody: cert?.winnersBody ?? source?.certificateWinnersBody ?? "",
    };
  };
  const hasCertificatePayload = (source) => {
    if (!source) return false;
    return (
      "certificates" in source ||
      "certificate" in source ||
      "certificateConfig" in source ||
      "certificado" in source ||
      "certificatesEnabled" in source ||
      "certificateEnabled" in source ||
      "certificateTitle" in source ||
      "certificateSubtitle" in source ||
      "certificateBody" in source ||
      "certificateSigner2Name" in source ||
      "certificateSigner2Role" in source ||
      "certificateSendEmail" in source ||
      "certificatesSendEmail" in source ||
      "certificateWinnersEnabled" in source ||
      "certificatesWinnersEnabled" in source ||
      "certificateWinnersBody" in source
    );
  };

useEffect(() => {
  if (editing && eventFromState) {
    prefillRef.current = true;
    setForm((f) => ({
      ...f,
      name: eventFromState.name || "",
      description: eventFromState.description || "",
      categoryid: eventFromState.categoryid?._id || eventFromState.categoryid || "",
      cityid: eventFromState.cityid?._id || eventFromState.cityid || "",
      stateid: eventFromState.stateid?._id || eventFromState.stateid || "",
      address: eventFromState.address || eventFromState.venueid?.address || "",
      lat: coordOf(eventFromState.lat, eventFromState.venueid?.latitude),
      lng: coordOf(eventFromState.lng, eventFromState.venueid?.longitude),
      // Avoid timezone shifts: treat date-only values as plain strings
      startDate: (eventFromState.startDatee || eventFromState.startDate || "").slice(0, 10),
      endDate: (eventFromState.endDatee || eventFromState.endDate || "").slice(0, 10),
      timeFrom: eventFromState.timeFrom || "",
      timeTo: eventFromState.timeTo || "",
      isFree: Boolean(eventFromState.isFree),
      price: eventFromState.price ?? 0,
      booking: Boolean(eventFromState.booking),
      maxbooking: eventFromState.maxbooking || 100,
      maxTicketsPerUser: eventFromState.maxTicketsPerUser || 4,
      instagram: eventFromState.instagram || "",
      ...resolveCertificate(eventFromState),
    }));
    if (eventFromState.image || eventFromState.headerimage || eventFromState.headerImage) {
      const candidateCover = eventFromState.image || eventFromState.headerimage || eventFromState.headerImage;
      const categoryImages = [
        eventFromState?.categoryid?.image,
        eventFromState?.categoryid?.headerimage,
        eventFromState?.categoryid?.headerImage,
      ].filter(Boolean);
      if (candidateCover && !categoryImages.includes(candidateCover)) {
        setCurrentCover(resolveUrl(candidateCover));
      } else {
        setCurrentCover("");
      }
    }
    setCoverImagePreview("");
    setGalleryDesktopPreview("");
    setGalleryMobilePreview("");
    setGalleryDesktopImage(null);
    setGalleryMobileImage(null);
    setClearGalleryDesktop(false);
    setClearGalleryMobile(false);
    if (eventFromState.mobileimage || eventFromState.mobileImage || eventFromState.mobile_image) {
      setCurrentMobileCover(
        resolveUrl(eventFromState.mobileimage || eventFromState.mobileImage || eventFromState.mobile_image)
      );
    }
    const gf = pickGallery(
      eventFromState.image2,
      eventFromState.images,
      eventFromState.multipleImage,
      eventFromState.multipleimage,
      eventFromState.gallery
    );
    const legacyFirst = gf[0] || "";
    const desktopGallery =
      eventFromState.galleryimage ||
      eventFromState.galleryImage ||
      eventFromState.galleryDesktopImage ||
      legacyFirst;
    const mobileGallery =
      eventFromState.gallerymobileimage ||
      eventFromState.galleryMobileImage ||
      eventFromState.galleryMobile ||
      legacyFirst;
    setCurrentGalleryDesktop(desktopGallery || "");
    setCurrentGalleryMobile(mobileGallery || "");
    const certTpl =
      eventFromState?.certificates?.templateImage ||
      eventFromState?.certificateTemplate ||
      eventFromState?.certificateTemplateImage ||
      "";
    if (certTpl) setCurrentCertificateTemplate(resolveUrl(certTpl));
    setClearCertificateTemplate(false);
    const winnersTpl =
      eventFromState?.certificates?.winnersTemplateImage ||
      eventFromState?.certificateWinnersTemplate ||
      eventFromState?.certificateWinnersTemplateImage ||
      "";
    if (winnersTpl) setCurrentCertificateWinnersTemplate(resolveUrl(winnersTpl));
    setClearCertificateWinnersTemplate(false);
    const certLogo =
      eventFromState?.certificates?.logoImage ||
      eventFromState?.certificateLogo ||
      "";
    if (certLogo) setCurrentCertificateLogo(resolveUrl(certLogo));
    setClearCertificateLogo(false);
    const certSig =
      eventFromState?.certificates?.signatureImage ||
      eventFromState?.certificateSignature ||
      "";
    if (certSig) setCurrentCertificateSignature(resolveUrl(certSig));
    setClearCertificateSignature(false);
    const certSig2 =
      eventFromState?.certificates?.signature2Image ||
      eventFromState?.certificateSignature2 ||
      "";
    if (certSig2) setCurrentCertificateSignature2(resolveUrl(certSig2));
    setClearCertificateSignature2(false);
  }
}, [editing, eventFromState]);

useEffect(() => {
  const DEFAULT_WINNERS_PHRASE =
    "Por su excepcional desempeño durante la competencia y ganar ante todos sus oponentes.";
  if (winnersEnabled && !String(form.certificateWinnersBody || "").trim()) {
    setForm((f) => ({ ...f, certificateWinnersBody: DEFAULT_WINNERS_PHRASE }));
  }
}, [winnersEnabled, form.certificateWinnersBody]);

  // Load base lists
  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const [catRes, stateRes, organizerRes] = await Promise.all([
          getCategory(),
          getState(),
          organizerMeApi().catch(() => null),
        ]);
        setCategories(Array.isArray(catRes?.data?.info) ? catRes.data.info : []);
        setStates(Array.isArray(stateRes?.data?.info) ? stateRes.data.info : []);
        setOrganizerProfile(organizerRes?.data?.info || null);
        if (!editing) {
          setInitialLoading(false);
        }
      } catch (e) {
        handleError(e);
        if (!editing) {
          setInitialLoading(false);
        }
      } finally { setIsLoading(false) }
    })();
  }, []);

  useEffect(() => {
    if (!isFreeOnlyOrganizer) return;
    setForm((prev) => {
      if (prev.isFree && Number(prev.price || 0) === 0) return prev;
      return { ...prev, isFree: true, price: 0 };
    });
    if (ticketTypes.length) {
      setTicketTypes([]);
    }
  }, [isFreeOnlyOrganizer, ticketTypes.length]);

  // Ensure full details (IDs + images) are loaded for editing
  useEffect(() => {
    const loadDetail = async () => {
      if (!editing || !id) return;
      try {
        setIsLoading(true);
        const res = await getEventById(id);
        if (res?.status === 200) {
          const ev = res.data?.info?.event || {};
          prefillRef.current = true;

          // Resolve IDs robustly: support id strings or plain names
          const stateList = states.length ? states : (await getState())?.data?.info || [];
          const findId = (list, idOrName) => {
            if (!idOrName) return "";
            // if already matches an id field
            const byId = list.find((x) => x._id === idOrName || x.id === idOrName);
            if (byId) return byId._id || byId.id;
            // else match by name/address
            const byName = list.find((x) => (x.name || x.address) === idOrName);
            return byName ? (byName._id || byName.id) : "";
          };

          const resolvedStateId = ev.stateid?._id || ev.stateid || findId(stateList, ev.state || ev.stateName);
          const citiesList = resolvedStateId ? (await fetchCitiesByState(resolvedStateId)) : [];
          const resolvedCityId = ev.cityid?._id || ev.cityid || findId(citiesList, ev.city || ev.cityName);

          setCities(citiesList);

          let organizerEvent = null;
          if (!hasCertificatePayload(ev)) {
            organizerEvent = eventFromState;
            if (!hasCertificatePayload(organizerEvent)) {
              try {
                const listRes = await organizerListEventsApi();
                const list = Array.isArray(listRes?.data?.info) ? listRes.data.info : [];
                organizerEvent = list.find(
                  (item) => String(item?.id || item?._id) === String(id)
                );
              } catch {}
            }
          }
          const certSource = hasCertificatePayload(ev) ? ev : organizerEvent;
          const certPayload = certSource ? resolveCertificate(certSource) : null;

          setForm((f) => ({
            ...f,
            name: ev.name || f.name,
            description: ev.description || f.description,
            categoryid: ev.categoryid?._id || ev.categoryid || f.categoryid,
            stateid: resolvedStateId || f.stateid,
            cityid: resolvedCityId || f.cityid,
            address: ev.address || ev.venueid?.address || f.address,
            lat: coordOf(ev.lat, ev.venueid?.latitude, f.lat),
            lng: coordOf(ev.lng, ev.venueid?.longitude, f.lng),
            startDate: ev.startDate ? ev.startDate.slice(0, 10) : f.startDate,
            endDate: ev.endDate ? ev.endDate.slice(0, 10) : f.endDate,
            timeFrom: ev.timeFrom || f.timeFrom,
            timeTo: ev.timeTo || f.timeTo,
            isFree: ev.isFree !== undefined ? Boolean(ev.isFree) : f.isFree,
            price: ev.price ?? f.price,
            booking: ev.booking !== undefined ? Boolean(ev.booking) : f.booking,
            maxbooking: ev.maxbooking || f.maxbooking,
            maxTicketsPerUser: ev.maxTicketsPerUser || f.maxTicketsPerUser || 4,
            instagram: ev.instagram || f.instagram || "",
            ...(certPayload || {}),
          }));

          // Normalize cover and gallery from various possible keys
          const coverCandidates = [ev.image, ev.headerimage, ev.headerImage, ev.cover];
          const cover = coverCandidates.find((c) => typeof c === 'string' && c.trim());
          const mobileCoverCandidates = [ev.mobileimage, ev.mobileImage, ev.mobile_image];
          const mobileCover = mobileCoverCandidates.find((c) => typeof c === 'string' && c.trim());
          const gallery = pickGallery(ev.image2, ev.images, ev.multipleImage, ev.multipleimage, ev.gallery);
          const legacyFirst = gallery[0] || "";
          const desktopGallery =
            ev.galleryimage || ev.galleryImage || ev.galleryDesktopImage || legacyFirst;
          const mobileGallery =
            ev.gallerymobileimage || ev.galleryMobileImage || ev.galleryMobile || legacyFirst;
          if (cover && !isCategoryImage(cover, ev)) setCurrentCover(resolveUrl(cover));
          if (mobileCover) setCurrentMobileCover(resolveUrl(mobileCover));
          setCurrentGalleryDesktop(desktopGallery || "");
          setCurrentGalleryMobile(mobileGallery || "");
          setCoverImagePreview("");
          setGalleryDesktopPreview("");
          setGalleryMobilePreview("");
          setGalleryDesktopImage(null);
          setGalleryMobileImage(null);
          setClearGalleryDesktop(false);
          setClearGalleryMobile(false);
          const certTpl =
            certSource?.certificates?.templateImage ||
            certSource?.certificateTemplate ||
            certSource?.certificateTemplateImage ||
            eventFromState?.certificates?.templateImage ||
            eventFromState?.certificateTemplate ||
            eventFromState?.certificateTemplateImage ||
            "";
          if (certTpl) {
            setCurrentCertificateTemplate(resolveUrl(certTpl));
          }
          setClearCertificateTemplate(false);
          const winnersTpl =
            certSource?.certificates?.winnersTemplateImage ||
            certSource?.certificateWinnersTemplate ||
            certSource?.certificateWinnersTemplateImage ||
            eventFromState?.certificates?.winnersTemplateImage ||
            eventFromState?.certificateWinnersTemplate ||
            eventFromState?.certificateWinnersTemplateImage ||
            "";
          if (winnersTpl) {
            setCurrentCertificateWinnersTemplate(resolveUrl(winnersTpl));
          }
          setClearCertificateWinnersTemplate(false);
          const certLogo =
            certSource?.certificates?.logoImage ||
            certSource?.certificateLogo ||
            eventFromState?.certificates?.logoImage ||
            eventFromState?.certificateLogo ||
            "";
          if (certLogo) {
            setCurrentCertificateLogo(resolveUrl(certLogo));
          }
          setClearCertificateLogo(false);
          const certSig =
            certSource?.certificates?.signatureImage ||
            certSource?.certificateSignature ||
            eventFromState?.certificates?.signatureImage ||
            eventFromState?.certificateSignature ||
            "";
          if (certSig) {
            setCurrentCertificateSignature(resolveUrl(certSig));
          }
          setClearCertificateSignature(false);
          const certSig2 =
            certSource?.certificates?.signature2Image ||
            certSource?.certificateSignature2 ||
            eventFromState?.certificates?.signature2Image ||
            eventFromState?.certificateSignature2 ||
            "";
          if (certSig2) {
            setCurrentCertificateSignature2(resolveUrl(certSig2));
          }
          setClearCertificateSignature2(false);

          // load ticket types for this event
          try {
            const tt = await organizerTicketTypesByEventApi({ eventid: id });
            if (tt?.status === 200) {
              const normalizedTypes = (Array.isArray(tt.data.info) ? tt.data.info : []).map((item) => ({
                ...item,
                ticketsPerUnit: resolveTicketsPerUnit(item, 1),
              }));
              setTicketTypes(normalizedTypes);
            }
          } catch {}

          prefillRef.current = false;
        }
      } catch (e) {
        handleError(e);
      } finally {
        setIsLoading(false);
        setInitialLoading(false);
      }
    };
    loadDetail();
  }, [editing, id]);

  // helpers
  const fetchCitiesByState = async (stateId) => {
    let res;
    try {
      res = await getCityByStateId({ stateId });
      if (res?.data?.info === undefined) throw new Error('unexpected_response');
      return Array.isArray(res.data.info) ? res.data.info : [];
    } catch (e1) {
      const res2 = await getCityByStateId({ stateid: stateId });
      return Array.isArray(res2?.data?.info) ? res2.data.info : [];
    }
  };

  const winnerAwardOptions = [
    { value: "Ganador/a", label: "Ganador/a" },
    { value: "1", label: "Primer puesto" },
    { value: "2", label: "Segundo puesto" },
    { value: "3", label: "Tercer puesto" },
  ];

  const normalizeWinnerCandidates = (list = []) => {
    const map = new Map();
    list.forEach((item) => {
      const email = String(item?.email || item?.buyerEmail || "").trim();
      if (!email) return;
      const isPresent = Number(item?.redeemedCount || 0) > 0 || Boolean(item?.is_present);
      if (!isPresent) return;
      const key = email.toLowerCase();
      if (map.has(key)) return;
      map.set(key, {
        name: item?.name || item?.buyerName || "Asistente",
        email,
        orderid: item?.orderid || "",
        ticketTypeName: item?.ticketTypeName || "",
      });
    });
    return Array.from(map.values());
  };

  const loadWinnerCandidates = async () => {
    if (!editing || !id) {
      setWinnerStatus("Guarda el evento para cargar asistentes.");
      return;
    }
    setWinnerStatus("");
    setWinnerLoading(true);
    try {
      const res = await organizerScannerAttendeeListApi(id);
      const list = Array.isArray(res?.data?.info) ? res.data.info : [];
      const normalized = normalizeWinnerCandidates(list);
      setWinnerCandidates(normalized);
      if (!normalized.length) {
        setWinnerStatus("Todavia no hay asistentes con ingreso registrado.");
      }
    } catch (e) {
      setWinnerStatus("No se pudo cargar la lista de asistentes.");
    } finally {
      setWinnerLoading(false);
    }
  };

  const handleWinnerToggle = (candidate, checked) => {
    if (!candidate?.email) return;
    const emailKey = candidate.email.toLowerCase();
    setWinnerSelection((prev) => {
      const next = { ...prev };
      if (!checked) {
        delete next[emailKey];
        return next;
      }
      next[emailKey] = {
        name: candidate.name,
        email: candidate.email,
        award: next[emailKey]?.award || "Ganador/a",
      };
      return next;
    });
  };

  const handleWinnerAwardChange = (email, award) => {
    if (!email) return;
    const emailKey = email.toLowerCase();
    setWinnerSelection((prev) => ({
      ...prev,
      [emailKey]: {
        ...(prev[emailKey] || { email, name: "" }),
        award,
      },
    }));
  };

  // Load cities when state changes
  useEffect(() => {
    const run = async () => {
      if (!form.stateid) return;
      try {
        const list = await fetchCitiesByState(form.stateid);
        setCities(list);
        if (prefillRef.current && form.cityid) {
          prefillRef.current = false;
        } else {
          setForm((f) => ({ ...f, cityid: "" }));
        }
      } catch (e) {
        handleError(e);
        setCities([]);
      }
    };
    run();
  }, [form.stateid]);

  useEffect(() => {
    if (!winnersEnabled) {
      setWinnerSelection({});
      setWinnerStatus("");
    }
  }, [winnersEnabled]);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (isFreeOnlyOrganizer && name === "isFree") {
      setForm((f) => ({ ...f, isFree: true, price: 0 }));
      return;
    }
    if (name === "certificatesEnabled" || name === "certificateSendEmail" || name === "certificateWinnersEnabled") {
      setCertStatus("");
      setWinnerStatus("");
    }
    if (isFreeOnlyOrganizer && name === "price") {
      setForm((f) => ({ ...f, price: 0 }));
      return;
    }
    setForm((f) => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const saveEvent = async ({ redirect = true } = {}) => {
    setSaving(true);
    setError("");
    try {
      if (isFreeOnlyOrganizer && (!form.isFree || Number(form.price || 0) > 0 || ticketTypes.length > 0)) {
        setError("Tu cuenta solo puede crear eventos gratuitos sin tipos de entrada.");
        return false;
      }
      if (!form.stateid || !form.cityid) {
        setError("Elegí la provincia y la ciudad del evento.");
        return false;
      }
      if (!String(form.address || "").trim()) {
        setError("Ingresá la dirección del evento.");
        return false;
      }
      const fd = new FormData();
      const certificateKeys = new Set([
        "certificatesEnabled",
        "certificateTitle",
        "certificateSubtitle",
        "certificateBody",
        "certificateSignerName",
        "certificateSignerRole",
        "certificateSigner2Name",
        "certificateSigner2Role",
        "certificateIssuer",
        "certificateEmailSubject",
        "certificateEmailBody",
        "certificateSendEmail",
        "certificateWinnersEnabled",
        "certificateWinnersBody",
      ]);
      Object.entries(form).forEach(([k, v]) => {
        if (certificateKeys.has(k)) return;
        // Blank lat/lng must be omitted, never sent as "": the backend only geocodes
        // the address when the keys are absent.
        if ((k === "lat" || k === "lng") && !Number.isFinite(Number(v === "" ? NaN : v))) return;
        fd.append(k, v);
      });
      const certificatesPayload = {
        certificatesEnabled: Boolean(certificatesEnabled),
        certificateTitle: form.certificateTitle || "",
        certificateSubtitle: form.certificateSubtitle || "",
        certificateBody: form.certificateBody || "",
        certificateSignerName: form.certificateSignerName || "",
        certificateSignerRole: form.certificateSignerRole || "",
        certificateSigner2Name: form.certificateSigner2Name || "",
        certificateSigner2Role: form.certificateSigner2Role || "",
        certificateIssuer: form.certificateIssuer || "",
        certificateEmailSubject: form.certificateEmailSubject || "",
        certificateEmailBody: form.certificateEmailBody || "",
        certificateSendEmail: Boolean(certificatesEnabled && form.certificateSendEmail),
        certificateWinnersEnabled: Boolean(certificatesEnabled && form.certificateWinnersEnabled),
        certificateWinnersBody: form.certificateWinnersBody || "",
      };
      Object.entries(certificatesPayload).forEach(([k, v]) => fd.append(k, v));
      if (image) fd.append('image', image);
      if (mobileImage) fd.append('mobileimage', mobileImage);
      if (galleryDesktopImage) fd.append('galleryimage', galleryDesktopImage);
      if (galleryMobileImage) fd.append('gallerymobileimage', galleryMobileImage);
      if (editing && clearGalleryDesktop && !galleryDesktopImage) {
        fd.append('clearGalleryImage', 'true');
      }
      if (editing && clearGalleryMobile && !galleryMobileImage) {
        fd.append('clearGalleryMobileImage', 'true');
      }
      let templateToUpload = certificateTemplate;
      if (!templateToUpload && certificatesEnabled && !currentCertificateTemplate) {
        try {
          templateToUpload = await fetchAsFile(certificateFallback, "Certificado.jpg");
        } catch {}
      }
      if (clearCertificateTemplate && !templateToUpload) {
        fd.append("certificateTemplateImage", "");
        fd.append("certificateTemplateKey", "");
      }
      if (templateToUpload) fd.append('certificateTemplate', templateToUpload);
      if (clearCertificateWinnersTemplate && !certificateWinnersTemplate) {
        fd.append("certificateWinnersTemplateImage", "");
        fd.append("certificateWinnersTemplateKey", "");
      }
      if (certificateWinnersTemplate) fd.append('certificateWinnersTemplate', certificateWinnersTemplate);
      if (clearCertificateLogo && !certificateLogo) {
        fd.append("certificateLogoImage", "");
        fd.append("certificateLogoKey", "");
      }
      if (certificateLogo) fd.append('certificateLogo', certificateLogo);
      if (clearCertificateSignature && !certificateSignature) {
        fd.append("certificateSignatureImage", "");
        fd.append("certificateSignatureKey", "");
      }
      if (certificateSignature) fd.append('certificateSignature', certificateSignature);
      if (clearCertificateSignature2 && !certificateSignature2) {
        fd.append("certificateSignature2Image", "");
        fd.append("certificateSignature2Key", "");
      }
      if (certificateSignature2) fd.append('certificateSignature2', certificateSignature2);
      if ((ticketTypes || []).length) {
        fd.append('ticketTypes', JSON.stringify(ticketTypes.map(t => ({
          id: t._id || t.id,
          name: t.name,
          description: t.description || "",
          price: Number(t.price || 0),
          ticketsPerUnit: resolveTicketsPerUnit(t, 1),
          capacity: Number(t.capacity || 0),
          promotion: normalizeTicketPromotion(t.promotion),
          status: !!t.status,
          sortOrder: Number(t.sortOrder || 0),
        }))));
      }
      if (editing) fd.append('id', id);

      const req = editing ? organizerUpdateEventApi : organizerAddEventApi;
      await req(fd);
      if (redirect) navigate('/organizer/events');
      return true;
    } catch (e) {
      handleError(e);
      setError(e?.response?.data?.message || 'Error saving event');
      return false;
    } finally {
      setSaving(false);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    await saveEvent({ redirect: true });
  };

  const handleCoverFile = (picked, inputEl = null) => {
    if (!picked) return;
    const file = pickValidUpload(picked, "Imagen de portada de venta", inputEl);
    if (!file) return;
    if (coverImagePreview) {
      try { URL.revokeObjectURL(coverImagePreview); } catch {}
    }
    setImage(file);
    setCoverImagePreview(URL.createObjectURL(file));
    setError("");
  };

  const handleGalleryDesktopFile = (picked, inputEl = null) => {
    if (!picked) return;
    const file = pickValidUpload(picked, "Galería de imágenes | Escritorio", inputEl);
    if (!file) return;
    if (galleryDesktopPreview) {
      try { URL.revokeObjectURL(galleryDesktopPreview); } catch {}
    }
    setGalleryDesktopImage(file);
    setGalleryDesktopPreview(URL.createObjectURL(file));
    setClearGalleryDesktop(false);
    setError("");
  };

  const handleMobileCoverFile = (picked, inputEl = null) => {
    if (!picked) return;
    const file = pickValidUpload(picked, "Imagen de portada móvil", inputEl);
    if (!file) return;
    if (mobileImagePreview) {
      try { URL.revokeObjectURL(mobileImagePreview); } catch {}
    }
    setMobileImage(file);
    setMobileImagePreview(URL.createObjectURL(file));
    setError("");
  };

  const handleGalleryMobileFile = (picked, inputEl = null) => {
    if (!picked) return;
    const file = pickValidUpload(picked, "Galería de imágenes | Móvil", inputEl);
    if (!file) return;
    if (galleryMobilePreview) {
      try { URL.revokeObjectURL(galleryMobilePreview); } catch {}
    }
    setGalleryMobileImage(file);
    setGalleryMobilePreview(URL.createObjectURL(file));
    setClearGalleryMobile(false);
    setError("");
  };

  const handleCertificateLogoFile = (picked, inputEl = null) => {
    if (!picked) return;
    const file = pickValidUpload(picked, "Logo del certificado", inputEl);
    if (!file) return;
    setCertificateLogo(file);
    setCurrentCertificateLogo(URL.createObjectURL(file));
    setClearCertificateLogo(false);
    setError("");
  };

  const handleCertificateSignatureFile = (picked, inputEl = null) => {
    if (!picked) return;
    const file = pickValidUpload(picked, "Firma", inputEl);
    if (!file) return;
    setCertificateSignature(file);
    setCurrentCertificateSignature(URL.createObjectURL(file));
    setClearCertificateSignature(false);
    setError("");
  };

  const handleCertificateSignature2File = (picked, inputEl = null) => {
    if (!picked) return;
    const file = pickValidUpload(picked, "Firma 2", inputEl);
    if (!file) return;
    setCertificateSignature2(file);
    setCurrentCertificateSignature2(URL.createObjectURL(file));
    setClearCertificateSignature2(false);
    setError("");
  };

  const handleClearCertificateLogo = () => {
    if (String(currentCertificateLogo || "").startsWith("blob:")) {
      try { URL.revokeObjectURL(currentCertificateLogo); } catch {}
    }
    setCertificateLogo(null);
    setCurrentCertificateLogo("");
    setClearCertificateLogo(true);
  };

  const handleClearCertificateSignature = () => {
    if (String(currentCertificateSignature || "").startsWith("blob:")) {
      try { URL.revokeObjectURL(currentCertificateSignature); } catch {}
    }
    setCertificateSignature(null);
    setCurrentCertificateSignature("");
    setClearCertificateSignature(true);
  };

  const handleClearCertificateSignature2 = () => {
    if (String(currentCertificateSignature2 || "").startsWith("blob:")) {
      try { URL.revokeObjectURL(currentCertificateSignature2); } catch {}
    }
    setCertificateSignature2(null);
    setCurrentCertificateSignature2("");
    setClearCertificateSignature2(true);
  };

  const handleClearCover = () => {
    if (coverImagePreview) { try { URL.revokeObjectURL(coverImagePreview); } catch {} }
    setImage(null);
    setCoverImagePreview("");
    setCurrentCover("");
  };

  const handleClearMobileCover = () => {
    if (mobileImagePreview) { try { URL.revokeObjectURL(mobileImagePreview); } catch {} }
    setMobileImage(null);
    setMobileImagePreview("");
    setCurrentMobileCover("");
  };

  const handleClearGalleryDesktop = () => {
    if (galleryDesktopPreview) {
      try { URL.revokeObjectURL(galleryDesktopPreview); } catch {}
    }
    setGalleryDesktopImage(null);
    setGalleryDesktopPreview("");
    setCurrentGalleryDesktop("");
    setClearGalleryDesktop(true);
  };

  const handleClearGalleryMobile = () => {
    if (galleryMobilePreview) {
      try { URL.revokeObjectURL(galleryMobilePreview); } catch {}
    }
    setGalleryMobileImage(null);
    setGalleryMobilePreview("");
    setCurrentGalleryMobile("");
    setClearGalleryMobile(true);
  };

  const handleSendCertificates = async () => {
    if (!editing || !id) return;
    if (!certificatesEnabled) {
      setCertStatus("Habilita los certificados y guarda el evento antes de enviar.");
      return;
    }
    if (!form.certificateSendEmail) {
      setCertStatus("Activa 'Enviar por mail' y guarda el evento antes de enviar.");
      return;
    }
    const saved = await saveEvent({ redirect: false });
    if (!saved) {
      setCertStatus("Primero guarda el evento con los cambios.");
      return;
    }
    setCertStatus("");
    setCertSending(true);
    try {
      const res = await organizerSendCertificatesApi({ eventId: id });
      const info = res?.data?.info || res?.data || {};
      const sent = info.sent ?? info.total ?? 0;
      const total = info.total ?? sent;
      setCertStatus(`Certificados enviados: ${sent}/${total}`);
    } catch (e) {
      setCertStatus(e?.response?.data?.message || "No se pudieron enviar los certificados.");
    } finally {
      setCertSending(false);
    }
  };

  const handleSendWinnerCertificates = async () => {
    if (!editing || !id) {
      setWinnerStatus("Guarda el evento para enviar diplomas.");
      return;
    }
    if (!winnersEnabled) {
      setWinnerStatus("Habilita la opcion de ganadores y guarda el evento.");
      return;
    }
    if (!form.certificateSendEmail) {
      setWinnerStatus("Activa 'Enviar por mail' y guarda el evento antes de enviar.");
      return;
    }
    const winners = Object.values(winnerSelection).filter((w) => w?.email);
    if (!winners.length) {
      setWinnerStatus("Selecciona al menos un ganador.");
      return;
    }
    const saved = await saveEvent({ redirect: false });
    if (!saved) {
      setWinnerStatus("Primero guarda el evento con los cambios.");
      return;
    }
    setWinnerStatus("");
    setWinnerSending(true);
    try {
      const payload = winners.map((w) => ({
        name: w.name || "",
        email: w.email,
        award: w.award || "",
      }));
      const res = await organizerSendWinnerCertificatesApi({ eventId: id, winners: payload });
      const info = res?.data?.info || res?.data || {};
      const sent = info.sent ?? info.total ?? 0;
      const total = info.total ?? sent;
      setWinnerStatus(`Diplomas enviados: ${sent}/${total}`);
    } catch (e) {
      setWinnerStatus(e?.response?.data?.message || "No se pudieron enviar los diplomas.");
    } finally {
      setWinnerSending(false);
    }
  };

  const handlePreviewCertificate = async () => {
    if (!editing || !id) {
      setCertStatus("Guarda el evento para descargar el ejemplo.");
      return;
    }
    const saved = await saveEvent({ redirect: false });
    if (!saved) {
      setCertStatus("Primero guarda el evento con los cambios.");
      return;
    }
    setCertStatus("");
    setCertPreviewing(true);
    try {
      const res = await organizerPreviewCertificateApi({ eventId: id, sampleName: "Ejemplo Nombre" });
      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "certificado-ejemplo.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      setCertStatus(e?.response?.data?.message || "No se pudo descargar el ejemplo.");
    } finally {
      setCertPreviewing(false);
    }
  };
  const filteredWinnerCandidates = winnerCandidates.filter((item) => {
    if (!winnerSearch) return true;
    const q = winnerSearch.toLowerCase();
    return (
      String(item?.name || "").toLowerCase().includes(q) ||
      String(item?.email || "").toLowerCase().includes(q) ||
      String(item?.ticketTypeName || "").toLowerCase().includes(q)
    );
  });
  const selectedWinnerCount = Object.keys(winnerSelection).length;
  const UploadIcon = () => (
    <svg className="ef-dropzone-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="17 8 12 3 7 8"/>
      <line x1="12" y1="3" x2="12" y2="15"/>
    </svg>
  );

  const FileUploadIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="17 8 12 3 7 8"/>
      <line x1="12" y1="3" x2="12" y2="15"/>
    </svg>
  );
  const TrashIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 6h18" />
      <path d="M8 6V4h8v2" />
      <path d="M19 6l-1 14H6L5 6" />
      <path d="M10 11v6M14 11v6" />
    </svg>
  );

  if (initialLoading) return <SpinLoading />;

  return (
    <div className="ef-page">

      {/* Alerts */}
      {editing && !eventFromState && (
        <div className="ef-alert ef-alert--warning">
          Abre esta pagina desde la lista de eventos para completar los campos.
        </div>
      )}
      {isFreeOnlyOrganizer && (
        <div className="ef-alert ef-alert--info">
          Esta cuenta solo puede organizar eventos gratis. Si queres vender entradas hace{" "}
          <a href="https://wa.me/5493813545650" target="_blank" rel="noreferrer"
            style={{ color: "inherit", textDecoration: "underline", fontWeight: 700 }}>
            click aqui
          </a>.
        </div>
      )}
      {error && <div className="ef-alert ef-alert--danger">{error}</div>}

      <form onSubmit={submit}>

        {/* Tab row */}
        <div className="ef-tab-row">
          <div className="ef-tabs">
            <div className="ef-tab">EDICIÓN</div>
          </div>
          <div className="ef-actions">
            <button type="submit" className="ef-btn ef-btn--primary ef-top-btn" disabled={saving}>
              {saving ? "Guardando..." : "Guardar"}
            </button>
            <button type="button" className="ef-btn ef-btn--ghost ef-top-btn" onClick={() => navigate("/organizer/events")}>
              Volver
            </button>
          </div>
        </div>

        {/* ===== Información general ===== */}
        <section className="ef-card">
          <div className="ef-card-header ef-card-header--tight">
            <h2 className="ef-card-title">Información general</h2>
          </div>

          <div className="ef-row ef-row--2" style={{ marginTop: 20 }}>
            <div className="ef-field">
              <label className="ef-label">Nombre</label>
              <input className="ef-input" name="name" value={form.name} onChange={onChange} required placeholder="Nombre del evento" />
            </div>
            <div className="ef-field">
              <label className="ef-label">Categoría</label>
              <OrganizerPillSelect
                placeholder="Selecciona categoría"
                value={form.categoryid}
                onChange={(val) => onChange({ target: { name: "categoryid", value: val } })}
                options={categories.map((c) => ({ value: c._id || c.id, label: c.name }))}
              />
            </div>
          </div>

          <div className="ef-row ef-row--2">
            <div className="ef-field">
              <label className="ef-label">Provincia</label>
              <OrganizerPillSelect
                placeholder="Selecciona provincia"
                value={form.stateid}
                onChange={(val) => onChange({ target: { name: "stateid", value: val } })}
                options={states.map((s) => ({ value: s._id || s.id, label: s.name }))}
              />
            </div>
            <div className="ef-field">
              <label className="ef-label">Ciudad</label>
              <OrganizerPillSelect
                placeholder={cities.length ? "Selecciona ciudad" : "Primero provincia"}
                value={form.cityid}
                onChange={(val) => onChange({ target: { name: "cityid", value: val } })}
                options={cities.map((c) => ({ value: c._id || c.id, label: c.name }))}
                searchable
                disabled={!cities.length}
              />
            </div>
          </div>

          <div className="ef-map-stack">
            <EventAddressMap
              address={form.address}
              lat={form.lat}
              lng={form.lng}
              locality={[
                cities.find((c) => String(c._id || c.id) === String(form.cityid))?.name,
                states.find((st) => String(st._id || st.id) === String(form.stateid))?.name,
              ].filter(Boolean).join(", ")}
              onChange={(patch) => setForm((f) => ({ ...f, ...patch }))}
            />
          </div>

          <div className="ef-row">
            <div className="ef-field">
              <label className="ef-label">Descripción del evento</label>
              <textarea className="ef-textarea" name="description" value={form.description} onChange={onChange}
                placeholder="Describí el evento, horarios, recomendaciones…" />
            </div>
          </div>

        </section>

        {/* ===== Configuración general ===== */}
        <section className="ef-card">
          <div className="ef-card-header ef-card-header--tight">
            <h2 className="ef-card-title">Configuración general</h2>
          </div>

          <div className="ef-config-layout" style={{ marginTop: 20 }}>
            <div className="ef-date-group">
              <div className="ef-field">
                <label className="ef-label">Inicio del evento</label>
                <div className="ef-date-row">
                  <EFDatePill
                    value={form.startDate}
                    onChange={(d) => onChange({ target: { name: "startDate", value: d ? d.format("YYYY-MM-DD") : "" } })}
                  />
                  <EFTimePill
                    value={form.timeFrom}
                    onChange={(val) => onChange({ target: { name: "timeFrom", value: val } })}
                  />
                </div>
              </div>
              <div className="ef-field">
                <label className="ef-label">Fin del evento</label>
                <div className="ef-date-row">
                  <EFDatePill
                    value={form.endDate}
                    onChange={(d) => onChange({ target: { name: "endDate", value: d ? d.format("YYYY-MM-DD") : "" } })}
                  />
                  <EFTimePill
                    value={form.timeTo}
                    onChange={(val) => onChange({ target: { name: "timeTo", value: val } })}
                  />
                </div>
              </div>
              <div className="ef-config-control ef-config-control--switch">
                <span className="ef-switch-text">
                  <span className="ef-switch-title">Evento gratuito</span>
                  <span className="ef-switch-sub">{isFreeOnlyOrganizer ? "Obligatorio para esta cuenta" : "Sin cobro de entradas"}</span>
                </span>
                <label className="ef-switch">
                  <input type="checkbox" name="isFree" checked={form.isFree} onChange={onChange} disabled={isFreeOnlyOrganizer} />
                  <span className="ef-track" />
                </label>
              </div>
            </div>

            <div className="ef-config-controls">
              <div className="ef-config-control ef-config-control--switch">
                <span className="ef-switch-text">
                  <span className="ef-switch-title">Reservas habilitadas</span>
                  <span className="ef-switch-sub">Permitir reservaciones previas</span>
                </span>
                <label className="ef-switch">
                  <input type="checkbox" name="booking" checked={form.booking} onChange={onChange} />
                  <span className="ef-track" />
                </label>
              </div>
              <div className="ef-config-control">
                <span className="ef-switch-text">
                  <span className="ef-switch-title">Máximo de reservas</span>
                  <span className="ef-switch-sub">Indique el número final</span>
                </span>
                <input className="ef-input ef-input--compact" type="number" name="maxbooking" value={form.maxbooking} onChange={onChange} min="0" />
              </div>
              <div className="ef-config-control">
                <span className="ef-switch-text">
                  <span className="ef-switch-title">Máximo por persona</span>
                  <span className="ef-switch-sub">Indique la cantidad de reservas</span>
                </span>
                <input className="ef-input ef-input--compact" type="number" name="maxTicketsPerUser" value={form.maxTicketsPerUser} onChange={onChange} min="1" />
              </div>
            </div>
          </div>
        </section>

        {/* ===== Tipos de entradas ===== */}
        {!form.isFree && (
          <section className="ef-card">
            <div className="ef-card-header">
              <div>
                <h2 className="ef-card-title">Tipos de entradas</h2>
                <p className="ef-card-sub">Configura los tickets disponibles para tu evento.</p>
              </div>
              <button
                type="button"
                className="ef-btn ef-btn--ghost"
                onClick={() =>
                  setTicketTypes((arr) => [
                    ...(arr || []),
                    {
                      name: "",
                      price: 0,
                      ticketsPerUnit: 1,
                      capacity: 0,
                      status: true,
                      sortOrder: arr?.length || 0,
                      description: "",
                      promotion: defaultPromotion(),
                    },
                  ])
                }
              >
                Agregar
              </button>
            </div>

            {ticketTypes.length === 0 && (
              <div className="ef-empty-state">
                <div className="ef-empty-icon-circle">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="8" x2="12" y2="16"/>
                    <line x1="8" y1="12" x2="16" y2="12"/>
                  </svg>
                </div>
                <p>Crea al menos un tipo<br/>de entrada para este evento</p>
              </div>
            )}

            <div className="ef-tickets-grid">
              {ticketTypes.map((t, idx) => {
                return (
                  <article className="ef-ticket-card" key={t._id || t.id || idx}>
                    <button type="button" className="ef-close" aria-label="Quitar"
                      onClick={() => setTicketTypes((arr) => arr.filter((_, i) => i !== idx))}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                        <path d="M6 6l12 12M18 6L6 18"/>
                      </svg>
                    </button>

                    <div className="ef-field">
                      <label className="ef-label">Nombre de entrada</label>
                      <input className="ef-input" value={t.name || ""}
                        onChange={(e) => setTicketTypes((arr) => arr.map((x, i) => i === idx ? { ...x, name: e.target.value } : x))} />
                    </div>

                    <div className="ef-row ef-row--3" style={{ marginTop: 14 }}>
                      <div className="ef-field">
                        <label className="ef-label">Precio</label>
                        <div className="ef-input-wrap">
                          <input className="ef-input ef-input--with-suffix" type="number" value={t.price || 0}
                            onChange={(e) => setTicketTypes((arr) => arr.map((x, i) => i === idx ? { ...x, price: Number(e.target.value) } : x))} />
                          <span className="ef-suffix">ARS</span>
                        </div>
                      </div>
                      <div className="ef-field">
                        <label className="ef-label">Entradas incluidas</label>
                        <input
                          className="ef-input"
                          type="number"
                          min="1"
                          value={resolveTicketsPerUnit(t, 1)}
                          onChange={(e) =>
                            setTicketTypes((arr) =>
                              arr.map((x, i) =>
                                i === idx ? { ...x, ticketsPerUnit: Math.max(1, Number(e.target.value) || 1) } : x
                              )
                            )
                          }
                        />
                      </div>
                      <div className="ef-field">
                        <label className="ef-label">Cupo total</label>
                        <input className="ef-input" type="number" value={t.capacity || 0}
                          onChange={(e) => setTicketTypes((arr) => arr.map((x, i) => i === idx ? { ...x, capacity: Number(e.target.value) } : x))} />
                      </div>
                    </div>

                    <div className="ef-row ef-row--2" style={{ marginTop: 14 }}>
                      <div className="ef-field">
                        <label className="ef-label">Orden</label>
                        <input className="ef-input" type="number" value={t.sortOrder || 0}
                          onChange={(e) => setTicketTypes((arr) => arr.map((x, i) => i === idx ? { ...x, sortOrder: Number(e.target.value) } : x))} />
                      </div>
                      <label className="ef-switch" style={{ alignSelf: "flex-end", paddingBottom: 10 }}>
                        <input type="checkbox" checked={!!t.status}
                          onChange={(e) => setTicketTypes((arr) => arr.map((x, i) => i === idx ? { ...x, status: e.target.checked } : x))} />
                        <span className="ef-track" />
                        <span className="ef-switch-text">
                          <span className="ef-switch-title">Activo</span>
                          <span className="ef-switch-sub">Stock disponible</span>
                        </span>
                      </label>
                    </div>

                    <div style={{ marginTop: 14 }}>
                      <textarea className="ef-textarea" placeholder="Descripción opcional" value={t.description || ""}
                        style={{ height: 90 }}
                        onChange={(e) => setTicketTypes((arr) => arr.map((x, i) => i === idx ? { ...x, description: e.target.value } : x))} />
                    </div>
                    {resolveTicketsPerUnit(t, 1) > 1 && (
                      <div className="ef-hint" style={{ marginTop: 10 }}>
                        Cada unidad vendida de este tipo emitirá {resolveTicketsPerUnit(t, 1)} entradas individuales.
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
          </section>
        )}

        {/* ===== Configuración visual ===== */}
        <section className="ef-card">
          <div className="ef-card-header ef-card-header--tight">
            <h2 className="ef-card-title">Configuración visual</h2>
          </div>

          <div className="ef-uploads-grid">
            {/* Portada */}
            <div className="ef-upload-tile">
              <label
                className={`ef-dropzone ${coverImagePreview || currentCover ? "has-image" : ""} ${dragTarget === "cover" ? "is-drag-over" : ""}`}
                htmlFor="ef-img-portada"
                {...createDropHandlers("cover", (file) => handleCoverFile(file))}
              >
                <input id="ef-img-portada" type="file" accept="image/*" hidden
                  onChange={(e) => {
                    handleCoverFile(e.target.files?.[0] || null, e.target);
                  }} />
                {coverImagePreview || currentCover
                  ? <>
                      <img src={coverImagePreview || resolveUrl(currentCover)} alt="Portada" />
                      <button type="button" className="ef-dropzone-remove" aria-label="Quitar imagen"
                        onClick={(e) => { e.preventDefault(); handleClearCover(); }}>
                        <TrashIcon />
                      </button>
                    </>
                  : <><UploadIcon /><div className="ef-dropzone-placeholder"><strong>Seleccionar archivo</strong><small>Peso máximo 10 MB</small></div></>
                }
              </label>
              <h4>Imagen de portada de venta</h4>
              <p className="ef-hint">Sube una imagen horizontal en alta resolución. 1600 x 900 px.</p>
            </div>

            {/* Galería escritorio */}
            <div className="ef-upload-tile">
              <label
                className={`ef-dropzone ${galleryDesktopPreview || currentGalleryDesktop ? "has-image" : ""} ${dragTarget === "galleryDesktop" ? "is-drag-over" : ""}`}
                htmlFor="ef-img-galeria"
                {...createDropHandlers("galleryDesktop", (file) => handleGalleryDesktopFile(file))}
              >
                <input id="ef-img-galeria" type="file" accept="image/*" hidden
                  onChange={(e) => {
                    handleGalleryDesktopFile(e.target.files?.[0] || null, e.target);
                  }} />
                {galleryDesktopPreview || currentGalleryDesktop
                  ? <>
                      <img src={galleryDesktopPreview || resolveUrl(currentGalleryDesktop)} alt="Galería escritorio" />
                      <button type="button" className="ef-dropzone-remove" aria-label="Quitar imagen"
                        onClick={(e) => { e.preventDefault(); handleClearGalleryDesktop(); }}>
                        <TrashIcon />
                      </button>
                    </>
                  : <><UploadIcon /><div className="ef-dropzone-placeholder"><strong>Seleccionar archivo</strong><small>Peso máximo 10 MB</small></div></>
                }
              </label>
              <h4>Galería de imágenes | Escritorio</h4>
              <p className="ef-hint">Imagen para mostrar en escritorio. 1468 x 920 px.</p>
            </div>

            {/* Portada móvil */}
            <div className="ef-upload-tile">
              <label
                className={`ef-dropzone ${mobileImagePreview || currentMobileCover ? "has-image" : ""} ${dragTarget === "coverMobile" ? "is-drag-over" : ""}`}
                htmlFor="ef-img-portada-movil"
                {...createDropHandlers("coverMobile", (file) => handleMobileCoverFile(file))}
              >
                <input id="ef-img-portada-movil" type="file" accept="image/*" hidden
                  onChange={(e) => {
                    handleMobileCoverFile(e.target.files?.[0] || null, e.target);
                  }} />
                {mobileImagePreview || currentMobileCover
                  ? <>
                      <img src={mobileImagePreview || resolveUrl(currentMobileCover)} alt="Portada móvil" />
                      <button type="button" className="ef-dropzone-remove" aria-label="Quitar imagen"
                        onClick={(e) => { e.preventDefault(); handleClearMobileCover(); }}>
                        <TrashIcon />
                      </button>
                    </>
                  : <><UploadIcon /><div className="ef-dropzone-placeholder"><strong>Seleccionar archivo</strong><small>Peso máximo 10 MB</small></div></>
                }
              </label>
              <h4>Imagen de portada móvil</h4>
              <p className="ef-hint">Se usa en vistas móviles de la ticketera. 1080 x 1920 px.</p>
            </div>

            {/* Galería móvil */}
            <div className="ef-upload-tile">
              <label
                className={`ef-dropzone ${galleryMobilePreview || currentGalleryMobile ? "has-image" : ""} ${dragTarget === "galleryMobile" ? "is-drag-over" : ""}`}
                htmlFor="ef-img-galeria-movil"
                {...createDropHandlers("galleryMobile", (file) => handleGalleryMobileFile(file))}
              >
                <input id="ef-img-galeria-movil" type="file" accept="image/*" hidden
                  onChange={(e) => {
                    handleGalleryMobileFile(e.target.files?.[0] || null, e.target);
                  }} />
                {galleryMobilePreview || currentGalleryMobile
                  ? <>
                      <img src={galleryMobilePreview || resolveUrl(currentGalleryMobile)} alt="Galería móvil" />
                      <button type="button" className="ef-dropzone-remove" aria-label="Quitar imagen"
                        onClick={(e) => { e.preventDefault(); handleClearGalleryMobile(); }}>
                        <TrashIcon />
                      </button>
                    </>
                  : <><UploadIcon /><div className="ef-dropzone-placeholder"><strong>Seleccionar archivo</strong><small>Peso máximo 10 MB</small></div></>
                }
              </label>
              <h4>Galería de imágenes | Móvil</h4>
              <p className="ef-hint">Imagen para mostrar en móvil. 1080 x 675 px.</p>
            </div>
          </div>

          <div className="ef-row" style={{ marginTop: 22 }}>
            <div className="ef-field">
              <label className="ef-label">Instagram del evento</label>
              <input className="ef-input" name="instagram" value={form.instagram} onChange={onChange}
                placeholder="@usuario o URL del perfil" />
            </div>
          </div>
        </section>

        {/* ===== Certificados para asistentes ===== */}
        <section className="ef-card">
          <div className="ef-card-header">
            <div>
              <h2 className="ef-card-title">Certificados para asistentes</h2>
              <p className="ef-card-sub">Configura el diploma y el correo que se enviará a quienes asistieron.</p>
            </div>
            <div className="ef-cert-header-right">
              {form.certificatesEnabled && editing && (
                <button type="button" className="ef-btn ef-btn--ghost"
                  onClick={handlePreviewCertificate} disabled={certPreviewing}>
                  {certPreviewing ? "Descargando..." : "Descargar ejemplo"}
                </button>
              )}
              <label className="ef-switch">
                <input type="checkbox" name="certificatesEnabled" checked={form.certificatesEnabled} onChange={onChange} />
                <span className="ef-track" />
              </label>
            </div>
          </div>

          {form.certificatesEnabled && (
            <div className="ef-cert-layout">
              {/* Columna izquierda */}
              <div className="ef-cert-col">
                <div className="ef-field">
                  <input className="ef-input" name="certificateTitle" value={form.certificateTitle} onChange={onChange}
                    placeholder="Título del certificado" />
                </div>
                <div className="ef-field">
                  <input className="ef-input" name="certificateSubtitle" value={form.certificateSubtitle} onChange={onChange}
                    placeholder="Subtítulo" />
                </div>
                <div className="ef-field">
                  <input className="ef-input" name="certificateIssuer" value={form.certificateIssuer} onChange={onChange}
                    placeholder="Organización" />
                </div>
                <div className="ef-row ef-row--2">
                  <div className="ef-field">
                    <input className="ef-input" name="certificateSignerName" value={form.certificateSignerName} onChange={onChange}
                      placeholder="Firmante" />
                  </div>
                  <div className="ef-field">
                    <input className="ef-input" name="certificateSignerRole" value={form.certificateSignerRole} onChange={onChange}
                      placeholder="Cargo" />
                  </div>
                </div>
                <div className="ef-row ef-row--2">
                  <div className="ef-field">
                    <input className="ef-input" name="certificateSigner2Name" value={form.certificateSigner2Name} onChange={onChange}
                      placeholder="Segundo firmante" />
                  </div>
                  <div className="ef-field">
                    <input className="ef-input" name="certificateSigner2Role" value={form.certificateSigner2Role} onChange={onChange}
                      placeholder="Cargo" />
                  </div>
                </div>
                <div className="ef-field ef-cert-body-field">
                  <textarea className="ef-textarea ef-cert-textarea" name="certificateBody" value={form.certificateBody} onChange={onChange}
                    placeholder="Texto del certificado" />
                  <p className="ef-footnote">*Usa variables como {"{NOMBRE}"}, {"{EVENTO}"}, {"{FECHA}"} para personalizar el contenido.</p>
                </div>
              </div>

              {/* Columna derecha */}
              <div className="ef-cert-col">
                <div className="ef-field">
                  <label className="ef-label">Logo del certificado</label>
                  <label
                    className={`ef-file-row ${dragTarget === "certLogo" ? "is-drag-over" : ""}`}
                    htmlFor="ef-cert-logo"
                    {...createDropHandlers("certLogo", (file) => handleCertificateLogoFile(file))}
                  >
                    <input id="ef-cert-logo" type="file" hidden accept="image/jpeg,image/png,image/svg+xml"
                      onChange={(e) => {
                        handleCertificateLogoFile(e.target.files?.[0] || null, e.target);
                      }} />
                    <span className="ef-file-meta">
                      <span className="ef-file-name">{currentCertificateLogo ? "Logo cargado" : "Seleccionar archivo"}</span>
                      <span className="ef-file-size">Peso máximo 10 MB</span>
                    </span>
                    <FileUploadIcon />
                  </label>
                  <p className="ef-footnote">*Logo pequeño que aparece en la parte superior.</p>
                  {currentCertificateLogo && (
                    <div className="ef-cert-asset-wrap">
                      <div className="ef-cert-asset"><img src={currentCertificateLogo} alt="Logo" /></div>
                      <button type="button" className="ef-icon-btn" aria-label="Quitar logo del certificado" onClick={handleClearCertificateLogo}>
                        <TrashIcon />
                      </button>
                    </div>
                  )}
                </div>

                <div className="ef-field">
                  <label className="ef-label">Firma ( PNG / SVG )</label>
                  <label
                    className={`ef-file-row ${dragTarget === "certSign1" ? "is-drag-over" : ""}`}
                    htmlFor="ef-cert-firma"
                    {...createDropHandlers("certSign1", (file) => handleCertificateSignatureFile(file))}
                  >
                    <input id="ef-cert-firma" type="file" hidden accept="image/jpeg,image/png,image/svg+xml"
                      onChange={(e) => {
                        handleCertificateSignatureFile(e.target.files?.[0] || null, e.target);
                      }} />
                    <span className="ef-file-meta">
                      <span className="ef-file-name">{currentCertificateSignature ? "Firma cargada" : "Seleccionar archivo"}</span>
                      <span className="ef-file-size">Peso máximo 10 MB</span>
                    </span>
                    <FileUploadIcon />
                  </label>
                  <p className="ef-footnote">*Se muestra arriba de la línea de firma.</p>
                  {currentCertificateSignature && (
                    <div className="ef-cert-asset-wrap">
                      <div className="ef-cert-asset"><img src={currentCertificateSignature} alt="Firma" /></div>
                      <button type="button" className="ef-icon-btn" aria-label="Quitar firma" onClick={handleClearCertificateSignature}>
                        <TrashIcon />
                      </button>
                    </div>
                  )}
                </div>

                <div className="ef-field">
                  <label className="ef-label">Firma 2 ( PNG / SVG )</label>
                  <label
                    className={`ef-file-row ${dragTarget === "certSign2" ? "is-drag-over" : ""}`}
                    htmlFor="ef-cert-firma2"
                    {...createDropHandlers("certSign2", (file) => handleCertificateSignature2File(file))}
                  >
                    <input id="ef-cert-firma2" type="file" hidden accept="image/jpeg,image/png,image/svg+xml"
                      onChange={(e) => {
                        handleCertificateSignature2File(e.target.files?.[0] || null, e.target);
                      }} />
                    <span className="ef-file-meta">
                      <span className="ef-file-name">{currentCertificateSignature2 ? "Firma 2 cargada" : "Seleccionar archivo"}</span>
                      <span className="ef-file-size">Peso máximo 10 MB</span>
                    </span>
                    <FileUploadIcon />
                  </label>
                  <p className="ef-footnote">*Firma del segundo director.</p>
                  {currentCertificateSignature2 && (
                    <div className="ef-cert-asset-wrap">
                      <div className="ef-cert-asset"><img src={currentCertificateSignature2} alt="Firma 2" /></div>
                      <button type="button" className="ef-icon-btn" aria-label="Quitar segunda firma" onClick={handleClearCertificateSignature2}>
                        <TrashIcon />
                      </button>
                    </div>
                  )}
                </div>

                <div className="ef-field">
                  <div className="ef-switch-row">
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 14, color: "var(--ef-ink)" }}>Enviar por mail a asistentes</div>
                      <p className="ef-hint" style={{ margin: "2px 0 0" }}>Se envía a quienes registraron asistencia.</p>
                    </div>
                    <label className="ef-switch">
                      <input type="checkbox" name="certificateSendEmail" checked={form.certificateSendEmail} onChange={onChange} />
                      <span className="ef-track" />
                    </label>
                  </div>
                </div>

                <div className="ef-field">
                  <input className="ef-input" name="certificateEmailSubject" value={form.certificateEmailSubject} onChange={onChange}
                    placeholder="Asunto del mail" />
                </div>

                <div className="ef-field ef-cert-body-field">
                  <textarea className="ef-textarea ef-cert-mail-textarea" name="certificateEmailBody" value={form.certificateEmailBody} onChange={onChange}
                    placeholder="Mensaje del mail" />
                </div>
              </div>
            </div>
          )}

          {form.certificatesEnabled && editing && (
            <div className="ef-cert-actions">
              {certStatus && <p className="ef-winner-status" style={{ margin: 0, alignSelf: "center" }}>{certStatus}</p>}
              <button type="button" className="ef-btn ef-btn--primary" style={{ fontSize: 13 }}
                onClick={handleSendCertificates} disabled={certSending || !form.certificateSendEmail}>
                {certSending ? "Enviando..." : "Enviar"}
              </button>
            </div>
          )}
          {!editing && certStatus && <p className="ef-winner-status" style={{ marginTop: 14 }}>{certStatus}</p>}
        </section>

        {/* ===== Diplomas para ganadores ===== */}
        <section className="ef-card">
          <div className="ef-card-header">
            <div>
              <h2 className="ef-card-title">Diplomas para ganadores</h2>
              <p className="ef-card-sub">Selecciona entre los asistentes y asígnales un puesto especial.</p>
            </div>
            <label className="ef-switch">
              <input type="checkbox" name="certificateWinnersEnabled" checked={form.certificateWinnersEnabled} onChange={onChange} />
              <span className="ef-track" />
            </label>
          </div>

          {form.certificateWinnersEnabled && (
            <>
              <div className="ef-diplomas-search-row">
                {editing && (
                  <button type="button" className="ef-btn ef-btn--ghost" style={{ height: 38, flexShrink: 0 }}
                    onClick={loadWinnerCandidates} disabled={winnerLoading}>
                    {winnerLoading ? "Cargando..." : "Cargar asistentes"}
                  </button>
                )}
                <div className="ef-input-wrap" style={{ flex: 1, minWidth: 0, width: '100%' }}>
                  <span className="ef-leading-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>
                    </svg>
                  </span>
                  <input className="ef-input" type="search" placeholder="Buscar por nombre o mail"
                    value={winnerSearch}
                    onChange={(e) => setWinnerSearch(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") e.preventDefault();
                    }}
                  />
                </div>
              </div>

              {!editing && <p className="ef-hint" style={{ marginTop: 10 }}>Guarda el evento para cargar asistentes.</p>}

              <div className="ef-diplomas-layout">
                <div>
                  <div className="ef-attendee-list">
                    {filteredWinnerCandidates.map((candidate) => {
                      const emailKey = candidate.email.toLowerCase();
                      const sel = Boolean(winnerSelection[emailKey]);
                      const award = winnerSelection[emailKey]?.award || "Ganador/a";
                      return (
                        <div key={emailKey} className="ef-attendee-row">
                          <input type="checkbox" checked={sel}
                            onChange={(e) => handleWinnerToggle(candidate, e.target.checked)} />
                          <div className="ef-attendee-who">
                            <div className="ef-attendee-name">{candidate.name}</div>
                            <div className="ef-attendee-mail">{candidate.email}</div>
                          </div>
                          <select className="ef-select" value={award}
                            onChange={(e) => {
                              if (!sel) handleWinnerToggle(candidate, true);
                              handleWinnerAwardChange(candidate.email, e.target.value);
                            }}>
                            {winnerAwardOptions.map((opt) => (
                              <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                          </select>
                        </div>
                      );
                    })}
                    {winnersEnabled && !filteredWinnerCandidates.length && editing && (
                      <p style={{ color: "var(--ef-muted)", fontSize: 13 }}>No hay asistentes disponibles.</p>
                    )}
                  </div>
                  <p className="ef-winner-count">{selectedWinnerCount} seleccionados</p>
                  {winnerStatus && <p className="ef-winner-status">{winnerStatus}</p>}
                </div>

                <div>
                  <div className="ef-field">
                    <label className="ef-label">Texto del diploma ganador</label>
                    <textarea className="ef-textarea ef-diploma-textarea" name="certificateWinnersBody"
                      value={form.certificateWinnersBody} onChange={onChange} disabled={!winnersEnabled}
                      placeholder="Por su excepcional desempeño durante la competencia y ganar ante todos sus oponentes." />
                    <p className="ef-footnote">*Usa {"{PUESTO}"} si querés incluir el puesto en el texto.</p>
                  </div>
                  {editing && winnersEnabled && (
                    <div className="ef-diploma-actions">
                      <button type="button" className="ef-btn ef-btn--primary"
                        onClick={handleSendWinnerCertificates} disabled={winnerSending || selectedWinnerCount === 0}>
                        {winnerSending ? "Enviando..." : "Enviar"}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </section>

      </form>
    </div>
  );
};

export default EventForm;
